import { Outlet } from 'react-router-dom';
import NewVersionChecker from '../modules/NewVersionChecker';

const RootLayout = () => {
  return (
    <>
      <NewVersionChecker />
      <Outlet />
    </>
  );
};

export default RootLayout;
